import ChatImgModal, {
  alertChatImageModal,
} from "components/modal/chat_img_modal";
import { alertWithDeposit } from "components/modal/deposit_modal";
import { alertWithDepositV2 } from "components/modal/deposit_modal_v2";
import LineOASelectorModal from "components/modal/line_oa_selector_modal";
import { pusher } from "components/PusherEvent";
import { MaxButton, StatusMaxButton } from "components/view/button";
import Spinner from "components/view/loader";
import { TextFieldFromSendChat } from "components/view/text_field_from";
import { replaceURLs } from "lib/helper/display_message";
import { pad2 } from "lib/helper/pad2";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
  GetPrefixLevel,
} from "lib/infomation_vender/document";
import { AppReducerStateProps } from "lib/store";
import { memberActionTypes } from "lib/store/member/reducer";
import create_room from "lib/worker/api/create_room";
import get_line_oa_settings_by_prefix, {
  LineOASettingResponse,
} from "lib/worker/api/get_line_oa_settings_by_prefix";
import get_message, { GetMessageResponse } from "lib/worker/api/get_message";
import get_room, { GetRoomResponse } from "lib/worker/api/get_room";
import get_vender_bank_account_from_member_by_id, {
  GetVenderBankAccountFromMemberByIDResponse,
} from "lib/worker/api/get_vender_bank_account_from_member_by_id";
import send_image from "lib/worker/api/send_image";
import send_message from "lib/worker/api/send_message";
import update_read_user from "lib/worker/api/update_read_user";
import upload_image from "lib/worker/api/upload_image";
import { uuidv4 } from "lib/worker/client";
import { GetServerSideProps } from "next";
import Link from "next/link";
import { useRouter } from "next/router";
import { Fragment, useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import LayoutMaster from "../../components/layout/layout_master";
import apigetinfo, {
  APIGetMemberInformation,
} from "../../lib/worker/api/getinfo";

interface ContactProps {
  state: AppReducerStateProps;
  bankVender: GetVenderBankAccountFromMemberByIDResponse;
  isLogin: boolean;
  username?: string | null;
  infomation: CheckWithPrefixResponse;
  lineOASettings?: LineOASettingResponse[];
  lineOASelectorRequested?: boolean;
}

function Contact(props: ContactProps) {
  const { isLogin } = props;
  const [chats, setChats] = useState<GetMessageResponse[]>([]);
  const [text, setText] = useState<string>("");
  const [roomInfomation, setRoomInfomation] = useState<GetRoomResponse>();
  const [usernamer, setUsernamer] = useState<string>("");
  const scrollRef = useRef<any>(null);
  const [updateMessageCount, setUpdateMessage] = useState<number>(0);
  const [image, setImage] = useState<any>();
  const [file, setFile] = useState<any>();
  const router = useRouter();
  const [loading, setloading] = useState<boolean>(false);
  const prefix = GetPrefixLevel(props.infomation);
  const visibleLineOASettings = (props.lineOASettings ?? []).filter(
    (setting) =>
      (setting.is_visible ?? false) && (setting.url ?? "").trim() !== "",
  );
  const shouldShowLineOASelector =
    visibleLineOASettings.length > 1 &&
    (!props.infomation.isChatWebsite || props.lineOASelectorRequested === true);

  useEffect(() => {
    if (
      (!props.infomation.isChatWebsite && visibleLineOASettings.length > 0) ||
      shouldShowLineOASelector
    ) {
      return;
    }

    let username_m = "";

    if (isLogin) {
      setloading(true);
      setUsernamer(props.username ?? "");
      get_vender_bank_account_from_member_by_id();
      setloading(false);
      apigetinfo();
      username_m = props.username ?? "";
    } else {
      if (localStorage.getItem("guest") == null) {
        localStorage.setItem("guest", `guest-${uuidv4()}`);
      }
      setUsernamer(localStorage.getItem("guest") ?? "");
      username_m = localStorage.getItem("guest") ?? "";
    }

    create_room({ prefix: prefix, username: username_m })
      .finally(() => {
        reloadGetMessage(true, username_m);
      })
      .catch((_err) => {});

    var channelReloadChatMessage = pusher.subscribe(
      "private-client-my-channel-chat-in-room-" + prefix + username_m,
    );

    var channelReloadRoomFrontEnd = pusher.subscribe(
      "private-client-my-channel-room-front-end-" + prefix + username_m,
    );

    channelReloadChatMessage.bind(`in-room`, () => {
      setUpdateMessage(updateMessageCount + 1);
      // reloadGetMessage(false, username_m);
      reloadRoom();
    });

    channelReloadRoomFrontEnd.bind(`in-room`, () => {
      reloadGetMessage(false, username_m);
    });

    setUpdateMessage(1);
    reloadGetMessage(true, username_m);

    update_read_user({ prefix: prefix ?? "", username: username_m });

    return () => {
      channelReloadChatMessage.unbind_all();
      channelReloadChatMessage.disconnect();
      channelReloadRoomFrontEnd.unbind_all();
      channelReloadRoomFrontEnd.disconnect();
    };
  }, [
    props.infomation.isChatWebsite,
    shouldShowLineOASelector,
    visibleLineOASettings.length,
  ]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behaviour: "smooth" });
    }
  }, [chats]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behaviour: "smooth" });
    }
  }, [chats]);

  const reloadRoom = () => {
    get_room({
      prefix: prefix,
      username: usernamer,
    })
      .then((json) => {
        setRoomInfomation(json);
      })
      .catch(() => {});
  };

  const reloadGetMessage = (isNew: boolean, username: string) => {
    get_message({
      prefix: prefix,
      username: username,
      chats: isNew ? [] : (chats ?? []),
    }).then((json) => {
      setChats([...chats, ...json]);
    });
  };

  const sendMessage = (event: any) => {
    event.preventDefault();
    if (text != "") {
      send_message({ prefix: prefix, username: usernamer, text: text });
    }

    if (image != null) {
      upload_image({ file: file }).then((json) => {
        send_image({
          prefix: prefix ?? "",
          username: usernamer,
          text: (json.result ?? [])[0].url ?? "",
        }).then(() => {
          setFile(null);
        });
      });
    }

    setText("");
    setImage(null);
    update_read_user({ prefix: prefix ?? "", username: usernamer });
  };

  const onImageChange = (event: any) => {
    event.preventDefault();
    if (event.target.files && event.target.files[0]) {
      setFile(event.target.files[0]);
      let reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target?.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const welcomeMessage = (): any => {
    if (isLogin) {
      return [
        {
          IsAdmin: true,
          Text: (
            <div>
              <div>สวัสดี ยินดีต้อนรับ</div>
              <li>
                บริการ{" "}
                <Link href="/bank">
                  <a style={{ textDecoration: "none" }}>
                    <span>ฝาก - ถอน 24 ชั่วโมง</span>
                  </a>
                </Link>
              </li>
              <li>หากปัญหาฝากเงิน</li>
              <li>เล่นเกมไม่ได้</li>
              <li>ลืมรหัสผ่าน</li>
              <li>เปลี่ยนรหัสผ่าน</li>
              <br></br>
              <div>สามารถสอบถามผ่านช่องทางสนทนาออนไลน์ได้ตลอด 24 ชั่วโมง</div>
            </div>
          ),
          TypeID: 0,
          CreateAt: 0,
        },
      ];
    } else {
      return [
        {
          IsAdmin: true,
          Text: (
            <div>
              สวัสดี ยินดีต้อนรับ
              <li>
                หากท่านยังไม่ได้สมัครสมาชิก{" "}
                <Link href={`/register/${prefix}`}>
                  <a>
                    <span>คลิกสมัครสมาชิก</span>
                  </a>
                </Link>
              </li>
              <li>
                หากท่านเป็นสมาชิกของทางเราโปรดคลิก{" "}
                <Link href={`/login/${prefix}`}>
                  <a>
                    <span>เข้าสู่ระบบ</span>
                  </a>
                </Link>
              </li>
              <li>
                บริการ{" "}
                <Link href="/bank">
                  <a style={{ textDecoration: "none" }}>
                    <span>ฝาก - ถอน 24 ชั่วโมง</span>
                  </a>
                </Link>
              </li>
              <br></br>
              <div>เจ้าหน้าที่ยินดีให้บริการตลอด 24 ชั่วโมง</div>
            </div>
          ),
          TypeID: 0,
          CreateAt: 0,
        },
      ];
    }
  };

  // const copyToClipboard = (content: any) => {
  //   const el = document.createElement("input");
  //   el.value = content;
  //   document.body.appendChild(el);
  //   el.select();
  //   document.execCommand("copy");
  //   document.body.removeChild(el);
  // };

  // const copysubmit = (e: any) => {
  //   let bankNumberCopy: any = bankVender?.BankNumber ?? "";
  //   e.target.textContent = "คัดลอกสำเร็จ";
  //   JSON.stringify(bankNumberCopy);
  //   copyToClipboard(bankNumberCopy);
  // };

  const [isLineOASelectorOpen, setIsLineOASelectorOpen] = useState(true);
  if (shouldShowLineOASelector) {
    return (
      <LayoutMaster
        content_setting={{
          title: "ติดต่อ Call Center",
          description:
            "ยินดีให้บริการ ทุกท่าน ตลอด 24 ชั่วโมง ผ่านระบบ แชท ที่มี ระบบ รักษาความปลอดภัยขั้นสูง ที่จะเก็บความลับ ของลูกค้า ทางเราดูแลลูกค้าเสมือนลูกค้า VIP ตลอด 24 ชม.",
        }}
        information={props.infomation}
      >
        <LineOASelectorModal
          isOpen={isLineOASelectorOpen}
          settings={visibleLineOASettings}
          onClose={() => {
            setIsLineOASelectorOpen(false);
            setTimeout(() => {
              router.push("/");
            }, 300);
          }}
          title={<>ช่องทางติดต่อ LINE OA</>}
        />
      </LayoutMaster>
    );
  }

  if (!props.infomation.isChatWebsite && visibleLineOASettings.length > 0) {
    return (
      <LayoutMaster
        content_setting={{
          title: "ติดต่อ Call Center",
          description:
            "ยินดีให้บริการ ทุกท่าน ตลอด 24 ชั่วโมง ผ่านระบบ แชท ที่มี ระบบ รักษาความปลอดภัยขั้นสูง ที่จะเก็บความลับ ของลูกค้า ทางเราดูแลลูกค้าเสมือนลูกค้า VIP ตลอด 24 ชม.",
        }}
        information={props.infomation}
      >
        <div
          className="children-top-margin-top-10 container"
          style={{ paddingTop: 20, paddingBottom: 40 }}
        >
          <h1>ช่องทางติดต่อ LINE OA</h1>
          <p>เลือกช่องทางที่ต้องการติดต่อเจ้าหน้าที่ได้จากรายการด้านล่าง</p>
          {visibleLineOASettings.map((setting, index) => (
            <div key={`line-oa-${index}`} style={{ marginTop: 10 }}>
              <a
                href={setting.url}
                className="btn background-blue-linear margin-top-10"
              >
                {(setting.name ?? "").trim() || `LINE OA ${index + 1}`}
              </a>
            </div>
          ))}
        </div>
      </LayoutMaster>
    );
  }

  return (
    <LayoutMaster
      content_setting={{
        title: "ติดต่อ Call Center",
        description:
          "ยินดีให้บริการ ทุกท่าน ตลอด 24 ชั่วโมง ผ่านระบบ แชท ที่มี ระบบ รักษาความปลอดภัยขั้นสูง ที่จะเก็บความลับ ของลูกค้า ทางเราดูแลลูกค้าเสมือนลูกค้า VIP ตลอด 24 ชม.",
      }}
      information={props.infomation}
    >
      <div
        className="children-top-margin-top-10 container"
        style={{ paddingBottom: 60 }}
      ></div>
      <ChatImgModal></ChatImgModal>
      <div style={{ marginRight: 10, marginLeft: 10, overflowX: "hidden" }}>
        <Fragment>
          {[...welcomeMessage(), ...(chats ?? [])].map(
            (message: GetMessageResponse, i) => {
              var t = new Date((message.CreateAt ?? 0) * 1000);
              var second = pad2(t.getSeconds());
              var min = pad2(t.getMinutes());
              var hour = pad2(t.getHours());
              var month = pad2(t.getMonth() + 1);
              var day = pad2(t.getDate());
              var year = t.getFullYear();
              var formattedDate =
                year +
                "-" +
                month +
                "-" +
                day +
                " " +
                hour +
                ":" +
                min +
                ":" +
                second;

              if (message.CreateAt == 0) {
                formattedDate = "";
              }

              const displayPlantText = () => {
                switch (message.TypeID) {
                  case 0:
                    if (message.IsAdmin) {
                      switch (message.Text) {
                        case "loff":
                          return (
                            <>
                              <h1>ช่องทางการเข้าสู่ระบบและการสมัครสมาชิก</h1>
                              <MaxButton
                                title="เข้าสู่ระบบ"
                                status={StatusMaxButton.submit}
                                onClick={() => {
                                  router.push(`/login/${prefix}`);
                                }}
                              ></MaxButton>
                              <div style={{ marginTop: 10 }}></div>
                              <MaxButton
                                title="สมัครสมาชิก"
                                status={StatusMaxButton.submit}
                                onClick={() => {
                                  router.push(`/register/${prefix}`);
                                }}
                              ></MaxButton>
                            </>
                          );
                        case "wwwoo":
                          return (
                            <div>
                              <h2>ฝากเงินผ่านระบบออโต้</h2>
                              <MaxButton
                                title="ช่องทางการเติมเงินระบบออโต้"
                                status={StatusMaxButton.submit}
                                onClick={() => {
                                  props.infomation.isPaymentV2
                                    ? alertWithDepositV2()
                                    : alertWithDeposit();
                                }}
                              ></MaxButton>
                            </div>
                          );
                        default:
                          return replaceURLs(message.Text ?? "") == null ? (
                            message.Text
                          ) : (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: replaceURLs(message.Text ?? "") ?? "",
                              }}
                            ></div>
                          );
                      }
                    } else {
                      return replaceURLs(message.Text ?? "") == null ? (
                        message.Text
                      ) : (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: replaceURLs(message.Text ?? "") ?? "",
                          }}
                        ></div>
                      );
                    }
                  case 1:
                    return (
                      <img
                        onClick={() => {
                          alertChatImageModal(`${message.Text}`);
                        }}
                        src={`${message.Text}`}
                        className="full-width-image"
                      ></img>
                    );
                  default:
                    return <div></div>;
                }
              };

              const displayContent = () => {
                if (message.IsAdmin) {
                  return (
                    <>
                      <div className="row" style={{ marginTop: -10 }}>
                        <div
                          style={{ textAlign: "left" }}
                          className="col-10 col-md-8 col-lg-8 col-xl-6"
                        >
                          <label className="msg-vender">
                            <div key={`ldisplay-${message.CreateAt}`}>
                              {displayPlantText()}
                            </div>
                          </label>
                          <div
                            className="font-timechat"
                            style={{
                              fontSize: 12,
                              marginTop: -14,
                            }}
                          >
                            {formattedDate}
                          </div>
                        </div>
                      </div>
                    </>
                  );
                } else {
                  return (
                    <>
                      <div className="row" style={{ marginTop: -10 }}>
                        <div style={{ flex: 1 }}></div>
                        <div
                          style={{ textAlign: "right" }}
                          className="col-10 col-md-8 col-lg-8 col-xl-6"
                        >
                          <label className="msg-send">
                            <div>{displayPlantText()}</div>
                          </label>
                          <div
                            className="font-timechat"
                            style={{
                              fontSize: 12,
                              marginRight: 15,
                              marginTop: -14,
                            }}
                          >
                            <div>{formattedDate}</div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                }
              };

              return <div key={i}>{displayContent()}</div>;
            },
          )}
        </Fragment>
      </div>
      {loading && (
        <div style={{ width: "100%", textAlign: "center" }}>
          <Spinner></Spinner>
        </div>
      )}
      {!loading && (
        <label
          className="font-timechat "
          style={{ width: "100%", textAlign: "center", fontSize: 12 }}
          ref={scrollRef}
        >
          {roomInfomation?.AdminCountUnRead == 0
            ? "เห็นแล้ว"
            : `ยังไม่เห็น ${
                roomInfomation?.AdminCountUnRead ?? 0
              } ข้อความของท่าน`}
        </label>
      )}
      <Form
        className="bg-color-bottom"
        style={{
          position: "fixed",
          left: 0,
          bottom: 78,
          right: 0,
        }}
        onSubmit={sendMessage}
      >
        <TextFieldFromSendChat
          title=""
          type="text"
          titleButton="ส่ง"
          value={text}
          image={image}
          onChange={(e) => {
            setText(e.target.value);
          }}
          onImageChange={onImageChange}
          onClick={sendMessage}
          isModalChatImage={image != null}
          closeModal={() => {
            setImage(null);
          }}
        ></TextFieldFromSendChat>
      </Form>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req } = context;
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  let lineOASettings: LineOASettingResponse[] = [];
  try {
    lineOASettings = await get_line_oa_settings_by_prefix({
      prefix: infomation.prefix,
    });
  } catch (_error) {}

  const visibleLineOASettings = lineOASettings.filter(
    (setting) =>
      (setting.is_visible ?? false) && (setting.url ?? "").trim() !== "",
  );

  if (!infomation.isChatWebsite) {
    if (visibleLineOASettings.length === 1) {
      return {
        redirect: {
          permanent: false,
          destination: visibleLineOASettings[0].url ?? "",
        },
        props: {},
      };
    }

    if (visibleLineOASettings.length === 0 && infomation.lineidchat) {
      return {
        redirect: {
          permanent: false,
          destination: infomation.lineidchat,
        },
        props: {},
      };
    }
  }

  try {
    const memberInfo = await APIGetMemberInformation({
      token: context.req.cookies.access_token,
    });

    return {
      props: {
        isLogin: req.cookies.access_token != undefined,
        username: memberInfo.Username,
        infomation: infomation,
        lineOASettings: lineOASettings,
        lineOASelectorRequested: context.query.line_oa_selector === "1",
      },
    };
  } catch (error) {
    return {
      props: {
        isLogin: req.cookies.access_token != undefined,
        username: null,
        infomation: infomation,
        lineOASettings: lineOASettings,
        lineOASelectorRequested: context.query.line_oa_selector === "1",
      },
    };
  }
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
    bankVender: state.member.bankVender,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onActionIsLogin: (isLogin: boolean) =>
      dispatch({
        type: memberActionTypes.ACTION_STATUS_IS_LOGIN,
        payload: isLogin,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
